import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/About/Organisms/JournalSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Heading/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Link/ULink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/LinkButtonArrow/LinkButtonArrow.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Page/About/AboutPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Page/Product/ProductsPage/ProductsPage.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Product/ProductCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Product/Products/Products.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sort/index.tsx");
